<!--通用时间选择器-->
<template>
  <div class="date-select">
    <div class="date-header clearfix">
      <span class="lastMonth monBtn" @click="changeMonth(-1)">&lt;</span>
      <span class="currentMonth fl">{{month}}月</span>
      <span class="currentYear fl">{{year}}年</span>
      <span class="nextMonth monBtn" @click="changeMonth(1)">&gt;</span>
    </div>
    <table class="dateTable" cellpadding="0" cellspacing="0">
      <thead>
        <tr>
          <th v-for="(week, weekIndex) in weeks" :key="weekIndex">{{week}}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(cell, cellIndex) in calendar" :key="cellIndex">
          <td
            v-for="(item, index) in cell"
            :key="index"
            :class="{
              'last-month': month !== item.month,
              'disableDate': disabledDate(item.data),
              'associated': associatedDate ? associatedDate(item.data) : ''
            }"
            @click="selectDate(item.data, disabledDate(item.data),associatedDate ? associatedDate(item.data) : '')"
          >
            <span
              :class="{
              'startSelect': options.dateType === 'start' && select === item.data,
              'endSelect': options.dateType === 'end' && select === item.data
            }"
            >{{item.day}}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    date: {
      type: String,
      default: ''
    },
    options: {
      type: Object,
      required: false,
      default: function () {
        return {
          disabledDate (time) {
            return new Date(time) < Date.now() - 8.64e7;
          },
          dateType: 'start'
        };
      }
    },
    disabledDate: {
      type: Function,
      default: function () {
        return function (time) {
          return new Date(time) < Date.now() - 8.64e7;
        };
      }
    },
    associatedDate: {
      type: Function
    }
  },
  data () {
    return {
      weeks: ['一', '二', '三', '四', '五', '六', '日'],
      calendar: [],
      year: '',
      month: '',
      current: '',
      select: '',
      activeColor: ''
    };
  },
  created () {
    this.showCalendar();
  },
  methods: {
    // 输出一个日历数据源  月份不必减1
    getCalendar (y, m) {
      y = parseInt(y);
      m = parseInt(m);
      let time = new Date(y, m - 1, 1);
      let lastDate, nextDate;
      let lastMonth = m - 1;
      let nextMonth = m + 1;
      if (m === 1) {
        lastDate = '' + (y - 1) + '-' + +12 + '-';
        nextDate = '' + y + '-' + 2 + '-';
        lastMonth = 12;
      } else if (m === 12) {
        lastDate = '' + y + '-' + 11 + '-';
        nextDate = '' + (y + 1) + '-' + 1 + '-';
        nextMonth = 1;
      } else {
        lastDate = '' + y + '-' + (m - 1) + '-';
        nextDate = '' + y + '-' + (m + 1) + '-';
      }
      let maxNumber = 42;
      let r1 = []; let r2 = []; let r3 = [];
      let lastFix = time.getDay() - 1;
      lastFix = lastFix < 0 ? lastFix + 7 : lastFix;
      let lastMaxDate = new Date(y, m - 1, 0).getDate(); // 上个月份最大天数
      let maxDate = new Date(y, m, 0).getDate(); // 当前月份的
      let i, t;
      for (i = 0; i < lastFix; i++) {
        t = lastMaxDate - lastFix + i + 1;
        r1[i] = { month: lastMonth, day: t, data: lastDate + t };
      }
      for (i = 0; i < maxDate; i++) {
        t = i + 1;
        r2[i] = { month: m, day: t, data: '' + y + '-' + +m + '-' + t };
      }
      let nextFix = maxNumber - maxDate - lastFix;
      for (i = 0; i < nextFix; i++) {
        t = i + 1;
        r3[i] = { month: nextMonth, day: t, data: nextDate + t };
      }
      let result = r1.concat(r2, r3);
      let ar = [];
      for (i = 0; i < 6; i++) {
        ar.push(result.splice(0, 7));
      }
      return ar;
    },
    showCalendar () {
      let day = ''; // 用于显示日历的日期
      // 验证是否是父组件传来的日期
      if (!this.date || this.date.length < 1) {
        day = new Date();
      } else {
        let outDate = this.date.split('-');
        day = new Date(outDate[0], outDate[1] - 1, outDate[2]);
      }
      // 验证日期是否有效
      if (Object.prototype.toString.call(day) === '[object Date]') {
        if (isNaN(day.getTime())) {
          day = new Date();
        } else {
          this.select = day.getFullYear() + '-' + (day.getMonth() + 1) + '-' + day.getDate();
        }
      } else {
        day = new Date();
      }
      // 获取当前的日期 并格式化 'YY-MM-DD'
      let curDate = new Date();
      this.current = '' + curDate.getFullYear() + '-' + (curDate.getMonth() + 1) + '-' + curDate.getDate();
      this.year = day.getFullYear();
      this.month = day.getMonth() + 1;
      this.calendar = this.getCalendar(this.year, this.month);
    },
    // 选择了的日期
    selectDate (date, flag1, flag2) {
      if (flag1) {
        return;
      }
      if (flag2) {
        return;
      }
      this.select = date;
      this.$emit('selected', this.patchZero(date));
    },
    changeMonth (flag) {
      if (flag === -1) {
        if (this.month === 1) {
          this.init(parseInt(this.year) - 1, 12);
        } else {
          this.init(this.year, parseInt(this.month) - 1);
        }
      } else {
        if (this.month === 12) {
          this.init(parseInt(this.year) + 1, 1);
        } else {
          this.init(this.year, parseInt(this.month) + 1);
        }
      }
    },
    init (y, m) {
      // 切换日历
      this.calendar = this.getCalendar(y, m);
      this.year = y;
      this.month = m;
    },
    // 补 0 操作
    patchZero (date) {
      let y = new Date(date).getFullYear();
      let m = new Date(date).getMonth() + 1;
      let d = new Date(date).getDate();
      m < 10 && (m = '0' + m);
      d < 10 && (d = '0' + d);
      return y + '-' + m + '-' + d;
    }
  },
  watch: {
    date () {
      this.showCalendar();
    }
  }
};
</script>

<style lang="scss">
.date-select {
  width: 296px;
  height: 342px;
  .date-header {
    width: 100%;
    height: 41px;
    padding-top: 15px;
    background: #f9f9f9;
    .monBtn {
      float: left;
      margin: 0 15px;
      font-size: 20px;
      color: #1d2b36;
      cursor: pointer;
    }
    .currentMonth {
      width: 71px;
      padding-right: 12px;
      text-align: right;
      font-size: 20px;
    }
    .currentYear {
      width: 111px;
      padding-left: 12px;
      text-align: left;
      font-size: 20px;
    }
  }
  .dateTable {
    padding: 0 18px;
    border-collapse: separate;
    thead {
      th {
        line-height: 45px;
      }
    }
    span {
      display: inline-block;
      width: 31px;
      height: 31px;
      line-height: 31px;
      text-align: center;
      border: 1px solid #ebecf1;
      border-radius: 2px 2px;
      margin: 2px;
      cursor: pointer;
    }
  }
  .startSelect {
    background: #def4ec;
    border-color: #def4ec !important;
  }
  .endSelect {
    background: #f7dedb;
    border-color: #f7dedb !important;
  }
  .last-month span {
    color: #b5c2ca;
    border-color: #f7f8fa !important;
    /*cursor: not-allowed;*/
  }
  .disableDate span {
    color: #c4c8ca;
    background: #f8f8f8;
    border-color: #f7f8fa !important;
    cursor: not-allowed;
  }
  .associated span {
    color: #c4c8ca;
    background: #f8f8f8;
    border-color: #f7f8fa !important;
    cursor: not-allowed;
  }
}
</style>
